import React from 'react';

export interface GuardService<S> {
  checkPermissions: (permissions: S) => boolean;
}

export interface GuardProps<S> extends React.PropsWithChildren {
  requiredPermissions: S;
  guardService: GuardService<S>;
  forbidden?: React.ReactNode;
}

export const Guard = <S,>(props: GuardProps<S>) => {
  const isAllowed = props.guardService.checkPermissions(props.requiredPermissions);

  if (isAllowed) {
    return props.children;
  }
  if (props.forbidden) {
    return props.forbidden;
  }
  return <></>;
};
